<div *kienePermission="[1301]">
    <kiene-kiene-table [tableDescriptor]="tableDescriptor" [attr.data-cy]="'atc_kiene_table'"></kiene-kiene-table>
</div>
